import { useRef, useEffect, useState } from "react";
import { createPopper } from "@popperjs/core";

export const PopupInfo = ({
  text = null,
  children = "i",
  placement = "top",
}) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);
  const popper = useRef(null);

  useEffect(() => {
    if (ref.current && popper.current) {
      createPopper(ref.current, popper.current, { placement });
    }
  }, []);

  return text !== null ? (
    <>
      <span
        ref={ref}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        className="inline-flex items-center justify-center text-xs w-5 h-5 rounded-full border border-gray-400 text-gray-600 cursor-help select-none bg-white hover:bg-gray-300 transition-colors duration-200 ml-auto mr-1"
      >
        {children}
      </span>
      <div
        ref={popper}
        className={`bg-gray-800 text-white text-xs rounded px-2 py-1 z-50 shadow transition-opacity duration-200 ${
          visible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        {text}
      </div>
    </>
  ) : null;
};

export default PopupInfo;
